// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"AffiliateCommissionForm_dropdown__1lPsH"};